import { PmfDisappointment, PmfQuestionType, PmfStepId } from '@griply/types';

import { PMF_SURVEY_CONFIG } from './config';

export const getPmfNextStepId = (
  currentStepId: PmfStepId,
  disappointment: PmfDisappointment | null,
): PmfStepId | null => {
  const step = PMF_SURVEY_CONFIG.steps[currentStepId];

  if (!step) {
    return null;
  }

  if (step.type === PmfQuestionType.SingleSelect) {
    return disappointment ? step.branch[disappointment] : null;
  }

  return step.next;
};
